module.exports = __webpack_public_path__ + "img/cp1-5.5f45c887.jpg";